module.exports = __webpack_public_path__ + "static/media/linkedin.4c6fecab.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/generic/layout/Overlay/assets/linkedin.svg
// module id = 1195
// module chunks = 0